import React, { useEffect, useState } from 'react'
import {
  Button,
  Box,
  IconButton,
  DialogActions,
  Dialog,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Typography
} from '@mui/material'
import { GridCloseIcon } from '@mui/x-data-grid'
import MercadoPagoButton from '../../../../components/Common/mp/MercadoPagoButton'

interface DialogPagoProps {
  open: boolean
  setOpen: (op: boolean) => void
  payload: any
  setOpenTransferencia: (op: boolean) => void
}

const DialogPago: React.FC<DialogPagoProps> = ({ open, setOpen, payload, setOpenTransferencia }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [preferenceId, setPreferenceId] = useState<string>(null)
  const [renderizado, setRenderizado] = useState<boolean>(false)

  const handleClose = () => {
    setOpen(false)
    setPreferenceId(null)
    setRenderizado(false)
  }

  const handleTransferencia = () => {
    setOpenTransferencia(true)
    handleClose()
  }

  useEffect(() => {
    if (payload?.linkPago) {
      const url = new URL(payload.linkPago)
      const preferenceId = url.searchParams.get('preference-id')
      if (preferenceId) {
        setPreferenceId(preferenceId)
      }
    }
  }, [payload, open])

  if (!preferenceId || !payload?.datosTransferencia) return

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          style: {
            overflowX: 'hidden',
            width: isMobile ? '90%' : '500px',
            height: '255.517px', // tamaño fijo para evitar salto
            maxHeight: 'unset'
          }
        }}
      >
        <DialogTitle style={{ display: 'flex', justifyContent: 'center', fontWeight: 'bold' }} variant="h5">
          Elegí el medio de pago
        </DialogTitle>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 30px',
            gap: '20px'
          }}
        >
          <Button
            variant="contained"
            onClick={handleTransferencia}
            color="success"
            sx={{ marginTop: '20px', width: '100%' }}
          >
            Transferencia
          </Button>
          <Box
            id="wallet_container"
            sx={{
              position: 'relative',
              minHeight: '60px',
              height: '60px',
              width: '100%',
            }}
          >
            {/* Placeholder mientras se carga */}
            {!renderizado && (
              <Box
                sx={{
                  position: 'absolute',
                  zIndex: 2,
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255,255,255,0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <Typography color="textSecondary">Para pagar por Mercado Pago aguardá unos segundos...</Typography>
              </Box>
            )}
            <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                opacity: renderizado ? 1 : 0,
                pointerEvents: renderizado ? 'auto' : 'none',
                transition: 'opacity 0.5s ease-in-out'
              }}
            >
              <MercadoPagoButton preferenceId={preferenceId} setRenderizado={setRenderizado} />
            </Box>
          </Box>
        </Box>
        <DialogActions>
          <IconButton
            edge="end"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '16px'
            }}
          >
            <GridCloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DialogPago
